import axiosFetch from './config';

export const getFeatures = async(flux)=>{
    const token = await localStorage.getItem('token')

    ////console.log("el token es: " + token );
    
    let typeOfFeatureIdParams = [];
    flux.forEach(element => {
        typeOfFeatureIdParams.push(`typeOfFeatureId=${element}`);
    });

    typeOfFeatureIdParams = typeOfFeatureIdParams.join('&');

    ////console.log(typeOfFeatureIdParams);

    return axiosFetch({
        method:'GET',
        url: `/feature?${typeOfFeatureIdParams}`,
        headers: {
          Authorization: 'Bearer ' + token,
        }
    })
}


export const getTypeOfFeatures = async(types)=>{
    const token = await localStorage.getItem('token')

    ////console.log("el token es: " + token );
    
    let typeOfFeatureIdParams = [];
    types.forEach(element => {
        typeOfFeatureIdParams.push(`typeOfFeatureId=${element}`);
    });
    

    typeOfFeatureIdParams = typeOfFeatureIdParams.join('&');

   // //console.log(typeOfFeatureIdParams);

    let url = `/feature?${typeOfFeatureIdParams}`
    ////console.log(url);

    return axiosFetch({
        method:'GET',
        url: `/feature?${typeOfFeatureIdParams}`,
        headers: {
          Authorization: 'Bearer ' + token,
        }
    })
}